export const regionsData = [
  {
    value: "Asia",
    label: "Asia",
    countries: [
      { value: "Afghanistan", label: "Afghanistan" },
      { value: "Armenia", label: "Armenia" },
      { value: "Azerbaijan", label: "Azerbaijan" },
      { value: "Bahrain", label: "Bahrain" },
      { value: "Bangladesh", label: "Bangladesh" },
      { value: "Bhutan", label: "Bhutan" },
      { value: "Brunei", label: "Brunei" },
      { value: "Cambodia", label: "Cambodia" },
      { value: "China", label: "China" },
      { value: "Cyprus", label: "Cyprus" },
      { value: "Georgia", label: "Georgia" },
      { value: "India", label: "India" },
      { value: "Indonesia", label: "Indonesia" },
      { value: "Iran", label: "Iran" },
      { value: "Iraq", label: "Iraq" },
      { value: "Israel", label: "Israel" },
      { value: "Japan", label: "Japan" },
      { value: "Jordan", label: "Jordan" },
      { value: "Kazakhstan", label: "Kazakhstan" },
      { value: "Kuwait", label: "Kuwait" },
      { value: "Kyrgyzstan", label: "Kyrgyzstan" },
      { value: "Laos", label: "Laos" },
      { value: "Lebanon", label: "Lebanon" },
      { value: "Malaysia", label: "Malaysia" },
      { value: "Maldives", label: "Maldives" },
      { value: "Mongolia", label: "Mongolia" },
      { value: "Myanmar", label: "Myanmar" },
      { value: "Nepal", label: "Nepal" },
      { value: "North Korea", label: "North Korea" },
      { value: "Oman", label: "Oman" },
      { value: "Pakistan", label: "Pakistan" },
      { value: "Palestine", label: "Palestine" },
      { value: "Philippines", label: "Philippines" },
      { value: "Qatar", label: "Qatar" },
      { value: "Saudi Arabia", label: "Saudi Arabia" },
      { value: "Singapore", label: "Singapore" },
      { value: "South Korea", label: "South Korea" },
      { value: "Sri Lanka", label: "Sri Lanka" },
      { value: "Syria", label: "Syria" },
      { value: "Taiwan", label: "Taiwan" },
      { value: "Tajikistan", label: "Tajikistan" },
      { value: "Thailand", label: "Thailand" },
      { value: "Timor-Leste", label: "Timor-Leste" },
      { value: "Turkey", label: "Turkey" },
      { value: "Turkmenistan", label: "Turkmenistan" },
      { value: "UAE", label: "United Arab Emirates" },
      { value: "Uzbekistan", label: "Uzbekistan" },
      { value: "Vietnam", label: "Vietnam" },
      { value: "Yemen", label: "Yemen" },
    ],
  },
  {
    value: "Africa",
    label: "Africa",
    countries: [
      { value: "Algeria", label: "Algeria" },
      { value: "Angola", label: "Angola" },
      { value: "Benin", label: "Benin" },
      { value: "Botswana", label: "Botswana" },
      { value: "Burkina Faso", label: "Burkina Faso" },
      { value: "Burundi", label: "Burundi" },
      { value: "Cabo Verde", label: "Cabo Verde" },
      { value: "Cameroon", label: "Cameroon" },
      { value: "CAR", label: "Central African Republic" },
      { value: "Chad", label: "Chad" },
      { value: "Comoros", label: "Comoros" },
      { value: "Congo", label: "Congo" },
      { value: "DRC", label: "Democratic Republic of the Congo" },
      { value: "Djibouti", label: "Djibouti" },
      { value: "Egypt", label: "Egypt" },
      { value: "Equatorial Guinea", label: "Equatorial Guinea" },
      { value: "Eritrea", label: "Eritrea" },
      { value: "Eswatini", label: "Eswatini" },
      { value: "Ethiopia", label: "Ethiopia" },
      { value: "Gabon", label: "Gabon" },
      { value: "Gambia", label: "Gambia" },
      { value: "Ghana", label: "Ghana" },
      { value: "Guinea", label: "Guinea" },
      { value: "Guinea-Bissau", label: "Guinea-Bissau" },
      { value: "Ivory Coast", label: "Ivory Coast" },
      { value: "Kenya", label: "Kenya" },
      { value: "Lesotho", label: "Lesotho" },
      { value: "Liberia", label: "Liberia" },
      { value: "Libya", label: "Libya" },
      { value: "Madagascar", label: "Madagascar" },
      { value: "Malawi", label: "Malawi" },
      { value: "Mali", label: "Mali" },
      { value: "Mauritania", label: "Mauritania" },
      { value: "Mauritius", label: "Mauritius" },
      { value: "Morocco", label: "Morocco" },
      { value: "Mozambique", label: "Mozambique" },
      { value: "Namibia", label: "Namibia" },
      { value: "Niger", label: "Niger" },
      { value: "Nigeria", label: "Nigeria" },
      { value: "Rwanda", label: "Rwanda" },
      { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
      { value: "Senegal", label: "Senegal" },
      { value: "Seychelles", label: "Seychelles" },
      { value: "Sierra Leone", label: "Sierra Leone" },
      { value: "Somalia", label: "Somalia" },
      { value: "South Africa", label: "South Africa" },
      { value: "South Sudan", label: "South Sudan" },
      { value: "Sudan", label: "Sudan" },
      { value: "Tanzania", label: "Tanzania" },
      { value: "Togo", label: "Togo" },
      { value: "Tunisia", label: "Tunisia" },
      { value: "Uganda", label: "Uganda" },
      { value: "Zambia", label: "Zambia" },
      { value: "Zimbabwe", label: "Zimbabwe" },
    ],
  },
  {
    value: "North America",
    label: "North America",
    countries: [
      { value: "Antigua and Barbuda", label: "Antigua and Barbuda" },
      { value: "Bahamas", label: "Bahamas" },
      { value: "Barbados", label: "Barbados" },
      { value: "Belize", label: "Belize" },
      { value: "Canada", label: "Canada" },
      { value: "Costa Rica", label: "Costa Rica" },
      { value: "Cuba", label: "Cuba" },
      { value: "Dominica", label: "Dominica" },
      { value: "Dominican Republic", label: "Dominican Republic" },
      { value: "El Salvador", label: "El Salvador" },
      { value: "Grenada", label: "Grenada" },
      { value: "Guatemala", label: "Guatemala" },
      { value: "Haiti", label: "Haiti" },
      { value: "Honduras", label: "Honduras" },
      { value: "Jamaica", label: "Jamaica" },
      { value: "Mexico", label: "Mexico" },
      { value: "Nicaragua", label: "Nicaragua" },
      { value: "Panama", label: "Panama" },
      { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis" },
      { value: "Saint Lucia", label: "Saint Lucia" },
      {
        value: "Saint Vincent and the Grenadines",
        label: "Saint Vincent and the Grenadines",
      },
      { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
      { value: "United States", label: "United States" },
    ],
  },
  {
    value: "South America",
    label: "South America",
    countries: [
      { value: "Argentina", label: "Argentina" },
      { value: "Bolivia", label: "Bolivia" },
      { value: "Brazil", label: "Brazil" },
      { value: "Chile", label: "Chile" },
      { value: "Colombia", label: "Colombia" },
      { value: "Ecuador", label: "Ecuador" },
      { value: "Guyana", label: "Guyana" },
      { value: "Paraguay", label: "Paraguay" },
      { value: "Peru", label: "Peru" },
      { value: "Suriname", label: "Suriname" },
      { value: "Uruguay", label: "Uruguay" },
      { value: "Venezuela", label: "Venezuela" },
    ],
  },
  {
    value: "Europe",
    label: "Europe",
    countries: [
      { value: "Albania", label: "Albania" },
      { value: "Andorra", label: "Andorra" },
      { value: "Austria", label: "Austria" },
      { value: "Belarus", label: "Belarus" },
      { value: "Belgium", label: "Belgium" },
      { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
      { value: "Bulgaria", label: "Bulgaria" },
      { value: "Croatia", label: "Croatia" },
      { value: "Czech Republic", label: "Czech Republic" },
      { value: "Denmark", label: "Denmark" },
      { value: "Estonia", label: "Estonia" },
      { value: "Finland", label: "Finland" },
      { value: "France", label: "France" },
      { value: "Germany", label: "Germany" },
      { value: "Greece", label: "Greece" },
      { value: "Hungary", label: "Hungary" },
      { value: "Iceland", label: "Iceland" },
      { value: "Ireland", label: "Ireland" },
      { value: "Italy", label: "Italy" },
      { value: "Latvia", label: "Latvia" },
      { value: "Liechtenstein", label: "Liechtenstein" },
      { value: "Lithuania", label: "Lithuania" },
      { value: "Luxembourg", label: "Luxembourg" },
      { value: "Malta", label: "Malta" },
      { value: "Moldova", label: "Moldova" },
      { value: "Monaco", label: "Monaco" },
      { value: "Montenegro", label: "Montenegro" },
      { value: "Netherlands", label: "Netherlands" },
      { value: "North Macedonia", label: "North Macedonia" },
      { value: "Norway", label: "Norway" },
      { value: "Poland", label: "Poland" },
      { value: "Portugal", label: "Portugal" },
      { value: "Romania", label: "Romania" },
      { value: "Russia", label: "Russia" },
      { value: "San Marino", label: "San Marino" },
      { value: "Serbia", label: "Serbia" },
      { value: "Slovakia", label: "Slovakia" },
      { value: "Slovenia", label: "Slovenia" },
      { value: "Spain", label: "Spain" },
      { value: "Sweden", label: "Sweden" },
      { value: "Switzerland", label: "Switzerland" },
      { value: "Ukraine", label: "Ukraine" },
      { value: "United Kingdom", label: "United Kingdom" },
      { value: "Vatican City", label: "Vatican City" },
    ],
  },
  {
    value: "Antarctica",
    label: "Antarctica",
    countries: [{ value: "Antarctica", label: "Antarctica" }],
  },
  {
    value: "Australia",
    label: "Australia & Oceania",
    countries: [
      { value: "Australia", label: "Australia" },
      { value: "Fiji", label: "Fiji" },
      { value: "Kiribati", label: "Kiribati" },
      { value: "Marshall Islands", label: "Marshall Islands" },
      { value: "Micronesia", label: "Micronesia" },
      { value: "Nauru", label: "Nauru" },
      { value: "New Zealand", label: "New Zealand" },
      { value: "Palau", label: "Palau" },
      { value: "Papua New Guinea", label: "Papua New Guinea" },
      { value: "Samoa", label: "Samoa" },
      { value: "Solomon Islands", label: "Solomon Islands" },
      { value: "Tonga", label: "Tonga" },
      { value: "Tuvalu", label: "Tuvalu" },
      { value: "Vanuatu", label: "Vanuatu" },
    ],
  },
];

export const provinces = [
  { value: "Alberta", label: "Alberta" },
  { value: "British Columbia", label: "British Columbia" },
  { value: "Manitoba", label: "Manitoba" },
  { value: "New Brunswick", label: "New Brunswick" },
  { value: "Newfoundland and Labrador", label: "Newfoundland and Labrador" },
  { value: "Northwest Territories", label: "Northwest Territories" },
  { value: "Nova Scotia", label: "Nova Scotia" },
  { value: "Nunavut", label: "Nunavut" },
  { value: "Ontario", label: "Ontario" },
  { value: "Prince Edward Island", label: "Prince Edward Island" },
  { value: "Quebec", label: "Quebec" },
  { value: "Saskatchewan", label: "Saskatchewan" },
  { value: "Yukon", label: "Yukon" },
];
